/**
 * Shared style objects for Marketplace and sub-components.
 */

export const iconStyle = {
  color: "#64748b",
  backgroundColor: "rgba(183, 191, 217, 0.1)",
  borderRadius: "50%",
  padding: "6px",
  margin: "0 2px",
  transition: "all 0.2s ease",
};

export const buddge = {
  display: "flex",
  height: 36,
  padding: "0 16px",
  justifyContent: "center",
  alignItems: "center",
  gap: 1,
  borderRadius: 9999,
  background: "#FFFFFF",
  border: "1px solid rgba(33, 34, 38, 0.06)",
  boxShadow: "0 1px 2px rgba(0,0,0,0.02)",
};

export const textBudge = {
  color: "#121317",
  fontFamily: "Inter, Poppins, sans-serif",
  fontSize: 14,
  fontWeight: 500,
};

export const empty = {
  color: "#64748b",
  fontFamily: "Inter, Poppins, sans-serif",
  fontSize: 16,
  fontWeight: 400,
  lineHeight: 1.6,
  mt: 3,
};

export const setBox = {
  background: "#FFFFFF",
  mt: 2,
  display: "flex",
  justifyContent: "center",
  alignContent: "center",
  alignItems: "center",
  flexDirection: "column",
  minHeight: 300,
  borderRadius: 4,
  border: "1px dashed rgba(33, 34, 38, 0.12)",
};

export const ButtonStyle = {
  width: "100%",
  height: "40px",
  border: "none",
  "&:hover": {
    cursor: "pointer",
    boxShadow: "1px 1px 5px 1px #ccc",
  },
  borderRadius: 2,
  fontFamily: "poppins",
  fontWeight: 400,
};

export const SubData = {
  color: "#868686",
  fontFamily: "Poppins",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
};

export const InputStyle = {
  color: "#818181",
  fontFamily: "Poppins",
  fontSize: 12,
  fontStyle: "normal",
  fontWeight: 400,
};

export const FieldBoxInput = {
  width: "100%",
  border: "1px solid #e6e9ee",
  borderRadius: 3,
  fontFamily: "Poppins",
  fontWeight: 500,
  padding: 10,
  fontSize: 11,
};

export const FieldBoxLabel = {
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: 11,
};

export const CommonTextStyle = {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "21px",
  color: "#6B7A99",
};
